exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.menu__content--select .room-list-last-checked {\n  float: right;\n  color: rgba(0,0,0,.54);\n}\n.table__report .activity_column--room_last_checked {\n  max-width: 130px;\n}\n.table__report .activity_column--room_label {\n  width: auto;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-db7d1a0e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/RoomPicker.vue
// module id = rutx
// module chunks = 1